import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import { Typography, TextareaAutosize } from "@mui/material";
import { Box } from "@mui/system";
import MuiTab from "./Tab/MuiTab";
import CommentsBox from "./comments/CommentsBox";
import useToaster from "../customHook/useToaster";
import useSafeInput from "../customHook/useSafeInput";
import { CHAR_LIMIT } from "../constants/utils";
import styles from "./CommonDescription.module.css";

const tabs = [{ label: "View Comment" }, { label: "Add New Comment" }];

const CommonDescription = ({
  minRows = 9,
  isHeadingHidden = false,
  heading = "Description",
  placeholder = "Enter Description",
  onSubmitButton = () => {},
  onChange = () => {},
  descriptionVal = "",
  descriptionRef,
  isButtonHidden = false,
  disabled = false,
  bgcolor = "#fff",
  isTabView = false,
  tabData = [],
  isFromHoldUnhold = false,
  limit,
}) => {
  const [activeTab, setActiveTab] = useState(0);
  const { showToast } = useToaster();

  //  HOOK USE
  const safeInput = useSafeInput({
    value: descriptionVal || "",
    onChange,
    showToast,
    limit: null,
  });

  const hasLimit =
    typeof (limit !== undefined
      ? limit
      : isFromHoldUnhold
        ? 250
        : CHAR_LIMIT) === "number";
  const displayLimit =
    limit !== undefined ? limit : isFromHoldUnhold ? 250 : CHAR_LIMIT;

  // Focus on tab switch
  useEffect(() => {
    safeInput.setValue("");
    if (tabs[activeTab]?.label === "Add New Comment") {
      document.getElementById("case-desc-input")?.focus();
    }
  }, [activeTab]);

  const handleSubmit = (e) => {
    if (!safeInput.value.trim()) {
      showToast("Please fill description", "info", true);
      return;
    }

    onSubmitButton(e);

    // clear after submit
    safeInput.setValue("");
    onChange({ target: { value: "" } });
  };

  useEffect(() => {
    safeInput.setValue(descriptionVal || "");
  }, [descriptionVal]);

  return (
    <Box
      className={`${styles.container} ${isTabView ? styles.containerTabView : ""}`}
    >
      {/* Heading */}
      <Typography
        className={`${styles.heading} ${isHeadingHidden ? styles.headingHidden : ""}`}
      >
        {heading}
      </Typography>

      {/* Tabs */}
      {isTabView && (
        <MuiTab
          tabs={tabs}
          variant="standard"
          fontSize="12px"
          standardMinContent
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      )}

      {isTabView && <Box sx={{ p: 1.5 }} />}

      {/* View Comments */}
      {tabs[activeTab]?.label === "View Comment" && isTabView && (
        <CommentsBox sidebarTable data={tabData} />
      )}

      {/* Add Comment */}
      {(tabs[activeTab]?.label === "Add New Comment" || !isTabView) && (
        <Box>
          <Box position="relative" width="100%">
            <TextareaAutosize
              id="case-desc-input"
              className={styles.textarea}
              disabled={disabled}
              minRows={minRows}
              maxRows={10}
              placeholder={placeholder}
              ref={descriptionRef}
              style={{ backgroundColor: bgcolor }}
              {...safeInput.bind}
            />
          </Box>

          {/* Submit Button */}
          {!isButtonHidden && (
            <div className={styles.buttonContainer}>
              <Button
                variant="contained"
                className={`${styles.submitButton} ${
                  safeInput.count > 0 ? styles.submitButtonActive : styles.submitButtonEmpty
                }`}
                onClick={handleSubmit}
              >
                Submit
              </Button>
            </div>
          )}
        </Box>
      )}
    </Box>
  );
};

export default CommonDescription;